import { DestroyService } from '@selfai-platform/shared';
import { ChartConfigService } from './chart-config.service';
import { ChartLegendService } from './chart-legend.service';

export function provideBaseChartServices() {
  return [DestroyService, ChartLegendService, ChartConfigService];
}
